import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class AccountService {
  constructor(private http: HttpClient) { }

  get(): Observable<any> {
    return this.http.get<Observable<any>>('api/account');
  }

  save(account: any): Observable<any> {
    return this.http.post<Observable<any>>('api/account', account);
  }
  getRoles(): Observable<any> {
    // const params = new HttpParams().append('permit', 'false');

    return this.http.get<any>('user/roles');//, { params: params });
  }
  account(): Observable<any> {
    return this.http.get<any>('user/contact');
  }

}
